import AspectAutocomplete from "@/app/(browse)/sell/(ad)/ad/form/AspectAutocomplete";
import { ItemAttributeOption } from "@/models/HomePageSearchResponse";
import { Controller, useFormContext } from "react-hook-form";

export default function ControlledAspectAutocomplete({
  name,
  label,
  options,
  showOptional,
  groupBy,
}: {
  name: string;
  label: string;
  options: ItemAttributeOption[];
  showOptional?: boolean;
  groupBy?: (option: ItemAttributeOption) => string;
}) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, ...fieldRest }, fieldState }) => (
        <AspectAutocomplete
          label={label}
          inputRef={ref}
          {...fieldRest}
          error={!!fieldState.error}
          helperText={fieldState.error ? fieldState.error.message : (showOptional && !fieldRest.value ? "Optional" : undefined)}
          options={options}
          groupBy={groupBy}
        />
      )}
    />
  );
}
